/**
 * Created by tschrader on 24.01.2017.
 */

/*
	WARNING: code taken from this chinese project here:
	https://github.com/egret-labs/egret-3d/blob/master/Sample/Sample-wing-blend-egret2d/EUI-Egret3D/libs/modules/egret/egret.js
 */
export class Matrix extends createjs.Matrix2D {

    public static DEG_TO_RAD = Math.PI / 180;

    /**
     * Creates the specific style of matrix expected by the beginGradientFill() and lineGradientStyle() methods of the Graphics class.
     * Width and height are scaled to a scaleX/scaleY pair and the tx/ty values are offset by half the width and height.
     * @param rotation in radius, same with flash
     */
    public createGradientBox(width: number, height: number, rotation: number, tx: number, ty: number): void {
        if (rotation === void 0) { rotation = 0; }
        if (tx === void 0) { tx = 0; }
        if (ty === void 0) { ty = 0; }
        this.createBox(width / 1638.4, height / 1638.4, rotation, tx + width / 2, ty + height / 2);
    }

    /**
     * @param rotation in radius, same with flash
     */
    public createBox(scaleX: number, scaleY: number, rotation: number, tx: number, ty: number): void {
        if (rotation === void 0) { rotation = 0; }
        if (tx === void 0) { tx = 0; }
        if (ty === void 0) { ty = 0; }
        var self = this;
        if (rotation !== 0) {
            // rotation = rotation / Matrix.DEG_TO_RAD;
            var u = Math.cos(rotation);
            var v = Math.sin(rotation);
            self.a = u * scaleX;
            self.b = v * scaleY;
            self.c = -v * scaleX;
            self.d = u * scaleY;
        }
        else {
            self.a = scaleX;
            self.b = 0;
            self.c = 0;
            self.d = scaleY;
        }
        self.tx = tx;
        self.ty = ty;
    };
}